import { render, staticRenderFns } from "./AvLinkPhone.vue?vue&type=template&id=1d2c34ec&lang=pug"
import script from "./AvLinkPhone.vue?vue&type=script&lang=ts"
export * from "./AvLinkPhone.vue?vue&type=script&lang=ts"
import style0 from "./AvLinkPhone.vue?vue&type=style&index=0&id=1d2c34ec&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
